import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */
import { useEffect, useState, } from 'react';
import { getMark, setMarks, getPluginType, useEventPlateId, usePlateEditorRef, usePlateEditorState, ToolbarButton, MARK_FONT_SIZE, select,
// removeMark,
// getMarks,
 } from '@udecode/plate';
import { TextField } from '@mui/material';
import TextIncreaseIcon from '@mui/icons-material/TextIncrease';
import TextDecreaseIcon from '@mui/icons-material/TextDecrease';
// const MARK_SELECTION_COLOR = 'selectionColor';
const FontSizeToolbarButtons = ({ id, pluginKey = MARK_FONT_SIZE, }) => {
    const eventEditorId = useEventPlateId(id);
    // console.log('eventEditorId', eventEditorId);
    const editor = usePlateEditorState(eventEditorId);
    // console.log('editor is', editor);
    const editorRef = usePlateEditorRef(eventEditorId);
    const type = getPluginType(editorRef, pluginKey);
    // const highlightType = getPluginType(editorRef, MARK_SELECTION_COLOR);
    const [selectedFontSize, setSelectedFontSize] = useState(16);
    useEffect(() => {
        const fontSizeValue = editorRef && getMark(editorRef, type);
        // console.log('useEffect called:', fontSizeValue, editor);
        if (editor?.selection) {
            setSelectedFontSize(fontSizeValue);
        }
    }, [editor, editor?.selection, editorRef, type]);
    const update = (ev, newFontSize) => {
        console.log('update called:', newFontSize);
        setSelectedFontSize(newFontSize);
        if (editorRef && editor && editor.selection) {
            select(editorRef, editor.selection);
            setMarks(editor, { [type]: newFontSize });
        }
    };
    if (selectedFontSize === undefined) {
        setSelectedFontSize('16'); // Default as per admin design
    }
    // console.log('fontSize:', selectedFontSize);
    return (_jsxs(_Fragment, { children: [_jsx(ToolbarButton, { icon: _jsx(TextDecreaseIcon, {}), onMouseDown: (event) => update(event, selectedFontSize ? parseInt(selectedFontSize, 10) - 1 : 12) }), _jsx(TextField, { name: "fontsize", size: "small", value: selectedFontSize, sx: {
                    width: '48px',
                    paddingY: 0.25,
                    input: { textAlign: 'center' },
                }, 
                // onFocus={() => {
                //   if (editorRef && editor && editor.selection) {
                //     highlightSelection(editor.selection);
                //   }
                // }}
                // onBlur={() => {
                //   if (editorRef && editor && editor.selection) {
                //     removeMark(editor, { key: highlightType });
                //   //  setMarks(editor, appliedMarks);
                //   }
                // }}
                onChange: (event) => {
                    const newSize = parseInt(event.target.value, 10);
                    if (newSize) {
                        setSelectedFontSize(newSize);
                    }
                    else if (event.target.value === '') {
                        setSelectedFontSize('');
                    }
                }, 
                // This is to prevent color picker from opening up when pressed enter key
                onKeyDown: (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        if (selectedFontSize) {
                            update(event, selectedFontSize);
                        }
                    }
                } }), _jsx(ToolbarButton, { icon: _jsx(TextIncreaseIcon, {}), onMouseDown: (event) => update(event, selectedFontSize ? parseInt(selectedFontSize, 10) + 1 : 12) })] }));
};
FontSizeToolbarButtons.defaultProps = {
    id: undefined,
    pluginKey: MARK_FONT_SIZE,
};
export default FontSizeToolbarButtons;
//# sourceMappingURL=FontSizeToolbarButtons.js.map